import React, { useState, useEffect } from "react";
import { useLocation, matchPath } from "react-router-dom";
import { routes } from "../routes/routes";
import CareiqSideBar from "../careiq/ui/CareIqSideBar";
import useModalStore from "zustand/zustandstore";


const SideBarWrapper = ({ children }) => {
  const location = useLocation();
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [patients, setPatients] = useState([]);

  const setModalValue = useModalStore((state) => state.setModalValue);
  const currentRoute = routes.find((route) =>
    matchPath(route.path, location.pathname)
  );

  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  // Load patient data from JSON files
  useEffect(() => {
    const jsonFiles = require.context("../careiq/jsons", false, /\.json$/);
    const loadedPatients = jsonFiles.keys().map((key) => {
      const data = jsonFiles(key);
      const info = data.patient_info || {};
      const name = info.name || "Unknown";
      const demographics = info.demographics || "";
      const dob = demographics.match(/DOB[:\s]+([\d-]+)/)?.[1] || "N/A";
      const id = info.id || key.match(/_(\d+)\.json$/)?.[1] || "N/A";

      return {
        label: `${name} | DOB: ${dob} | ID: ${id}`,
        value: key,
        content: data,
        id,
        name,
        dob,
      };
    });

    setPatients(loadedPatients);

    // Set the first patient to Zustand initially
    if (loadedPatients.length > 0) {
      setModalValue({ careiqRecord: loadedPatients[0] });
    }
  }, [setModalValue]);

  return (
    <div className="relative flex h-screen w-screen overflow-hidden">
      {currentRoute?.isSidebar && (
        <CareiqSideBar
          isSidebarOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
          patients={patients} // 👈 pass down patients
        />
      )}

      <div
        className={`
          flex-1 h-full overflow-auto
          transition-all duration-300 
        `}
      >
        {currentRoute?.isSidebar && !isSidebarOpen && (
          <div className="absolute top-4 left-4 z-50">
            <button
              onClick={toggleSidebar}
              className="p-2 bg-gray-200 rounded-md shadow-md text-xs"
            >
              ☰
            </button>
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

export default SideBarWrapper;
